var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwaStatusOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9621_23289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3438 12.4805C18.3438 15.7942 15.6575 18.4805 12.3438 18.4805C9.03004 18.4805 6.34375 15.7942 6.34375 12.4805C6.34375 9.16676 9.03004 6.48047 12.3438 6.48047C15.6575 6.48047 18.3438 9.16676 18.3438 12.4805Z",
    fill: "#338808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8438 12.4805C17.8438 15.518 15.3813 17.9805 12.3438 17.9805V18.9805C15.9336 18.9805 18.8438 16.0703 18.8438 12.4805H17.8438ZM12.3438 17.9805C9.30618 17.9805 6.84375 15.518 6.84375 12.4805H5.84375C5.84375 16.0703 8.7539 18.9805 12.3438 18.9805V17.9805ZM6.84375 12.4805C6.84375 9.4429 9.30618 6.98047 12.3438 6.98047V5.98047C8.7539 5.98047 5.84375 8.89062 5.84375 12.4805H6.84375ZM12.3438 6.98047C15.3813 6.98047 17.8438 9.4429 17.8438 12.4805H18.8438C18.8438 8.89062 15.9336 5.98047 12.3438 5.98047V6.98047Z",
    fill: "#245F06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9621_23289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.34375 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwaStatusOnline);
export default __webpack_public_path__ + "static/media/fwa-status-online.feef871c4793d00986a0b750bd77da37.svg";
export { ForwardRef as ReactComponent };